import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  fetchMidpointMediaCrmLead,
  patchMidpointMediaCrmLead,
} from "../../../api/midpointMediaAdminApi";
import {
  ClientPortalError,
  ClientPortalLoading,
} from "../../../components/clientPortal/ClientPortalStates";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import { formatClientDateTime } from "../../../utils/clientPortalFormat";
import "../../../styles/midpointMediaAdmin.css";

const STATUSES = ["new", "contacted", "qualified", "converted", "nurturing", "closed"];

export default function MidpointMediaAdminCrmLeadDetailPage() {
  const { leadId } = useParams();
  const { clientViewId, paths, viewBase } = useMidpointMediaAdminView();
  const [state, setState] = useState({ loading: true, error: "", lead: null, saving: false });

  useEffect(() => {
    if (!clientViewId || !leadId) return undefined;
    let cancelled = false;
    fetchMidpointMediaCrmLead(clientViewId, leadId)
      .then((body) => {
        if (!cancelled) setState({ loading: false, error: "", lead: body.lead, saving: false });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, error: error.message, lead: null, saving: false });
      });
    return () => {
      cancelled = true;
    };
  }, [clientViewId, leadId]);

  const onStatus = async (event) => {
    const status = event.target.value;
    setState((current) => ({ ...current, saving: true }));
    try {
      const body = await patchMidpointMediaCrmLead(clientViewId, leadId, { status });
      setState((current) => ({ ...current, saving: false, lead: body.lead }));
    } catch (error) {
      setState((current) => ({ ...current, saving: false, error: error.message }));
    }
  };

  if (state.loading) return <ClientPortalLoading message="Loading lead…" />;
  if (state.error && !state.lead) return <ClientPortalError message={state.error} />;
  if (!state.lead) return <p className="empty-state">Lead not found.</p>;

  const lead = state.lead;

  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">
          <Link to={`${paths.base}/crm/leads`}>Leads</Link>
        </p>
        <h1>{lead.name}</h1>
        <p className="mm-admin-lead">
          {lead.referenceId ? `Reference ${lead.referenceId}. ` : ""}
          {lead.roleType || lead.leadType || "Lead"} · {formatClientDateTime(lead.createdAt)}
        </p>
      </header>
      {state.error ? <ClientPortalError message={state.error} /> : null}
      <section className="mm-admin-grid" style={{ gridTemplateColumns: "1.2fr 0.8fr" }}>
        <article className="mm-admin-card">
          <h2>Application / message</h2>
          <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit", margin: 0 }}>
            {lead.message || "No message."}
          </pre>
        </article>
        <article className="mm-admin-card">
          <h2>Contact</h2>
          <p>{lead.email || "—"}</p>
          <p>{lead.phone || "—"}</p>
          <p>{lead.city || "—"}</p>
          <label>
            Status
            <select value={lead.status} onChange={onStatus} disabled={state.saving}>
              {STATUSES.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </label>
          {lead.opportunityId && viewBase ? (
            <p>
              <Link to={`${viewBase}/opportunities/${lead.opportunityId}`}>Open opportunity</Link>
            </p>
          ) : null}
        </article>
      </section>
    </div>
  );
}
